/**
 * Definitions of the logger instance.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */
import { getIampLogger } from '@amplify3/duplo-back-end'
import { isEnvProduction } from './env'

export const LOG_TAG_LIST = import.meta.env.VITE_LOG_TAG
export const logger = getIampLogger(!isEnvProduction, LOG_TAG_LIST)
